import { SegmentCarouselDisplay } from 'components/ui/SegmentCarouselDisplay';
import { withHuggg } from 'hoc';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getSegments } from 'redux/modules/huggg';

export const SegmentCarousel = (props) => {
  const { huggg, segments, onSelectSegment, isVirginBrandProduct, disabled } =
    props;

  return (
    <SegmentCarouselDisplay
      huggg={huggg}
      segments={segments}
      onSelectSegment={onSelectSegment}
      isVirginBrandProduct={isVirginBrandProduct}
      disabled={disabled}
    />
  );
};

SegmentCarousel.propTypes = {
  huggg: PropTypes.object,
  segments: PropTypes.array,
  onSelectSegment: PropTypes.func,
  isVirginBrandProduct: PropTypes.bool,
  disabled: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    segments: getSegments(state),
  };
};

export default compose(withHuggg, connect(mapStateToProps))(SegmentCarousel);
